import {SisName} from 'util/SisName';
import {SisNameUrl} from 'util/SisNameUrl';

export const ET_BOOKING = SisName.Booking;
export const ET_BOOKING_URL = SisNameUrl[SisName.Booking];

export const ET_PERSURL = SisName.Persurl;
export const ET_PERSURL_URL = SisNameUrl[SisName.Persurl];

export const EntityAttributes: { [sisName in SisName]?: string[] } = {
	[SisName.Persurl]: ['id', 'persNr', 'start', 'end', 'hourCategory', 'openMarking', 'representative', 'altRepresentative', 'text', 'cf'],
	[SisName.Booking]: ['bookingNr', 'persNr', 'bookingDate', 'bookingTime', 'bookingTimespan', 'bookingType', 'hourCategory', 'bewEinh', 'empfEinh', 'einstuf', 'stKey', 'stTagKey', 'text', 'mdat', 'cf'],
	[SisName.StTagZu]: ['persNr', 'date', 'soll', 'normalBegin', 'normalEnd', 'kernBegin', 'kernEnd', 'glzBegin', 'glzEnd'],
	[SisName.PlanTempl]: ['planTag', 'bookingTime', 'bookingTimespan', 'bookingType', 'hourCategory', 'bewEinh', 'empfEinh', 'stKey', 'stTagKey', 'text'],
};

export const WorkflowChangeableFields = ['text'];
